module.exports = __webpack_public_path__ + "7144636edd1a7ce69dacf2a688f2ca7b.jpg";